<template>
  <div class="box">
    <el-button size="small" type="primary" v-print="'#printTest'"
      >打印</el-button
    >
    <div id="printTest">
      <div
        class="box_printTest"
        v-for="(item_cm, index_cm) in printArr"
        :key="index_cm"
        style="page-break-after: always"
      >
        <!-- <p class="code_tit">
          {{ "20230920001" }}
        </p> -->
        <p class="code_tit mb15">
          {{ item_cm }}
        </p>
        <div class="code_box">
          <PreviewQrCode
            :width="130"
            :height="130"
            :labelNo="item_cm"
          ></PreviewQrCode>
        </div>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
export default {
  components: {
    PreviewQrCode: () => import("../../views/qrCode/previewQrCode.vue"),
  },
  props: {
    printArr: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style scoped>
.box {
  background: white;
  overflow-y: auto;
}
.box_printTest {
  width: 100mm;
  /* height: 60mm; */
  height: 55mm;
  font-family: "宋体";
  color: black;
  padding-top: 30px;
  box-sizing: border-box;
  font-size: 20px;
  line-height: 23px;
  text-align: center;
}
.code_box {
  width: 130px;
  margin: 0 auto;
}
.code_tit {
  margin: 0;
  font-weight: bold;
}
.mb15 {
  margin-bottom: 10px;
}

/* 去掉页眉页脚 */
@page {
  size: auto;
  margin: 0mm;
}
</style>
